function simpleHash(input: string): string {
  let hash = 0;
  if (input.length === 0) return hash.toString();
  for (let i = 0; i < input.length; i++) {
    const char = input.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash = hash & hash;
  }
  return Math.abs(hash).toString();
}

const sentryErrorCounts: Record<string, number> = {};
export function hasErrorReachedReportingThreshold(errorMessage: string, threshold = 20): boolean {
  const hashedErrorMessage = simpleHash(errorMessage);
  const errorName = `sentry-error-${hashedErrorMessage}`;
  const currentCount = sentryErrorCounts[errorName] || 0;

  sentryErrorCounts[errorName] = currentCount + 1;

  return sentryErrorCounts[errorName] >= threshold;
}
